// src/layouts/AdminLayout.jsx
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../pages/DG/Sidebar';

const DgLayout = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex h-screen">
      {/* Sidebar à gauche */}
      <Sidebar collapsed={collapsed} onCollapseChange={setCollapsed} />

      {/* Contenu principal */}
      <div
        className="flex-1 flex flex-col transition-all duration-300"
        style={{ marginLeft: collapsed ? '80px' : '256px' }}
      >
        {/* Barre de navigation en haut */}


        {/* Zone de rendu des pages */}
        <main className="flex-1 p-6 bg-gray-50 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DgLayout;